export const OPEN_ALERT = 'OPEN_ALERT';


export const handleAlert = (data) => ({
  type: OPEN_ALERT,
  data
});
